var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666626 5.99999C0.666626 5.53975 1.03972 5.16666 1.49996 5.16666H16.5C16.9602 5.16666 17.3333 5.53975 17.3333 5.99999C17.3333 6.46023 16.9602 6.83332 16.5 6.83332H1.49996C1.03972 6.83332 0.666626 6.46023 0.666626 5.99999Z",
    fill: "#44546F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666626 0.99999C0.666626 0.539753 1.03972 0.166656 1.49996 0.166656H16.5C16.9602 0.166656 17.3333 0.539753 17.3333 0.99999C17.3333 1.46023 16.9602 1.83332 16.5 1.83332H1.49996C1.03972 1.83332 0.666626 1.46023 0.666626 0.99999Z",
    fill: "#44546F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666626 11C0.666626 10.5398 1.03972 10.1667 1.49996 10.1667H16.5C16.9602 10.1667 17.3333 10.5398 17.3333 11C17.3333 11.4602 16.9602 11.8333 16.5 11.8333H1.49996C1.03972 11.8333 0.666626 11.4602 0.666626 11Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.4dc421662ea3cf4d8c9460c01eb1b1c2.svg";
export { ForwardRef as ReactComponent };